// extracted by mini-css-extract-plugin
export default {"root":"PL4ZyenLKYcihf72yQgS","items":"gNaJeHAdP6kg1_Gb69Dl","label":"CWskgacZuz5LUuH9WMvc","placeHolderShimmer":"jMMsJJpAPeWlKaSfXOP_"};